import { configWithUserToken } from "../../services/config";
import { IOnCallAgent, IOnCallAgentCreate, IOnCallUserOption } from "../models/IOnCallAgent";
import { getLiveChatAgents } from "./liveChatAgent";

export const getOnCallAgents = () =>
  configWithUserToken.get<IOnCallAgent[]>("LiveChatAgent/on-call");

export const addOnCallAgent = (payload: IOnCallAgentCreate) =>
  configWithUserToken.post<IOnCallAgent>("LiveChatAgent/on-call", payload);

export const deleteOnCallAgent = (onCallAgentId: string) =>
  configWithUserToken.delete(`LiveChatAgent/on-call/${onCallAgentId}`);

export const patchOnCallAgent = (onCallAgentId: string, isActive: boolean) =>
  configWithUserToken.patch(`LiveChatAgent/on-call/${onCallAgentId}`, { isActive });

export const getOnCallUserList = (): Promise<IOnCallUserOption[]> =>
  getLiveChatAgents().then((res) =>
    res.data.map((u) => ({
      id: u.userId,
      displayName: `${u.customerName} ${u.customerSurName}`.trim(),
      phoneNumber: u.customerTelNo ?? "",
    }))
  );
